import React, { useEffect, useState } from "react";
import { coverCandidates } from "../utils/mediaUrl";

export function EventCoverImage({
  src,
  alt,
  className,
  imgClassName,
}: {
  src: string;
  alt: string;
  className?: string;
  imgClassName?: string;
}) {
  const candidates = coverCandidates(src);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    setIdx(0);
  }, [src]);

  const current = candidates[idx];
  if (!current) return null;

  return (
    <img
      src={current}
      alt={alt}
      className={imgClassName ?? className}
      onError={() => setIdx((i) => i + 1)}
    />
  );
}
